module.exports = __webpack_public_path__ + "media/images/filter-gray-9b8ee7607748674e4a37ef1dd7fa94eb.svg";